import { SmartLink } from "@selector/shared/components";
import { type FC } from "react";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const HitRankCell: FC<IAgGridCellProps> = (props) => {
  const { value, data } = props;
  if (!data) {
    return null;
  }
  const rank = value;

  const tooltip = `Go to alignment of hit ${rank}`;
  return (
    <TableCell>
      <SmartLink to={`/job/${data.jobId}/results/${data.queryId}/alignments/${rank}`} tooltip={tooltip} forceTooltip>
        {value}
      </SmartLink>
    </TableCell>
  );
};

export default HitRankCell;
